import { render } from "./AdminCase.vue?vue&type=template&id=7038cf6f&scoped=true"
import script from "./AdminCase.vue?vue&type=script&lang=js"
export * from "./AdminCase.vue?vue&type=script&lang=js"

import "./AdminCase.vue?vue&type=style&index=0&id=7038cf6f&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7038cf6f"]])

export default __exports__